<canvas [width]="width()" [height]="height()"></canvas>
